import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMiljogebyrKlager } from "../../../../actions/miljogebyrerActions";
import Klageinformasjon from "../../Detalj/Klageinformasjon";

export default function KlageinformasjonContainer({ miljogebyrId }) {
  const miljogebyrKlager = useSelector((state) => state.miljogebyrKlager);
  const dispatch = useDispatch();

  useEffect(() => {
    if (miljogebyrId) dispatch(getMiljogebyrKlager(miljogebyrId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Klageinformasjon klager={miljogebyrKlager} />;
}

KlageinformasjonContainer.propTypes = {
  miljogebyrId: PropTypes.string,
};
